// src/stores/auth.js

import { defineStore } from 'pinia';
import api from '../api';

export const useAuthStore = defineStore('auth', {
  state: () => ({
    user: null,
    token: localStorage.getItem('userToken') || null,
    refreshTokenValue: localStorage.getItem('refreshToken') || null,
  }),
  getters: {
    isAuthenticated: (state) => !!state.token,
    userInfo: (state) => state.user,
  },
  actions: {
    async login(username, password) {
      try {
        const response = await api.post('/api/auth/login', { username, password });

        // ✅ lấy từ response.data.data
        const { accessToken, refreshToken } = response.data.data;

        this.token = accessToken;
        this.refreshTokenValue = refreshToken;
        this.user = { username }; // BE chưa trả user info nên mình set username

        localStorage.setItem('userToken', accessToken);
        localStorage.setItem('refreshToken', refreshToken);
        localStorage.setItem('user', JSON.stringify(this.user));

        api.defaults.headers.common['Authorization'] = `Bearer ${accessToken}`;

        return response.data;
      } catch (error) {
        this.logout();
        throw error;
      }
    },

    async refreshToken() {
      try {
        const refreshToken = this.refreshTokenValue || localStorage.getItem('refreshToken');
        if (!refreshToken) return this.logout();

        const response = await api.post('/api/auth/refresh', { refreshToken });

        const { accessToken } = response.data.data;
        this.token = accessToken;

        localStorage.setItem('userToken', accessToken);
        api.defaults.headers.common['Authorization'] = `Bearer ${accessToken}`;

        return accessToken;
      } catch (error) {
        this.logout();
        throw error;
      }
    },

    logout() {
      this.user = null;
      this.token = null;
      this.refreshTokenValue = null;

      localStorage.removeItem('userToken');
      localStorage.removeItem('refreshToken');
      localStorage.removeItem('user');
      delete api.defaults.headers.common['Authorization'];
    },

    initialize() {
      const storedUser = localStorage.getItem('user');
      const storedToken = localStorage.getItem('userToken');

      if (storedUser) {
        this.user = JSON.parse(storedUser);
      }
      if (storedToken) {
        api.defaults.headers.common['Authorization'] = `Bearer ${storedToken}`;
      }
    },
  },
});
